// Sandwich Items
import ChickenTikkaSandwich from "../images/FOOD_ITEMS/ChickenTikkaSandwich.png";
import ChickenTeriyakiSandwich from "../images/FOOD_ITEMS/ChickenTeriyakiSandwich.png";
import PlainChickenSandwich from "../images/FOOD_ITEMS/PlainChickenSandwich.png";
import TurkeySandwich from "../images/FOOD_ITEMS/TurkeySandwich.png";
import MeatballsSandwich from "../images/FOOD_ITEMS/MeatballsSandwich.png";
import TunaSandwich from "../images/FOOD_ITEMS/TunaSandwich.png";
import HamSandwich from "../images/FOOD_ITEMS/HamSandwich.png";
import PepperoniSandwich from "../images/FOOD_ITEMS/PepperoniSandwich.png";
import SalamiSandwich from "../images/FOOD_ITEMS/SalamiSandwich.png";
import VegetableSandwich from "../images/FOOD_ITEMS/VegetableSandwich.png";
import ShreddedBeefSandwich from "../images/FOOD_ITEMS/ShreddedBeefSandwich.png";
import ChickenStripSandwich from "../images/FOOD_ITEMS/ChickenStripSandwich.png";
import CreateYourOwn from "../images/FOOD_ITEMS/ShreddedBeefSandwich.png";
import samplePng from "../images/FOOD_ITEMS/Sample.jpg";

// Drinks
import Pepsi16oz from "../images/FOOD_ITEMS/Sample.jpg";
import Water500ml from "../images/FOOD_ITEMS/Sample.jpg";
import PepsiMax16oz from "../images/FOOD_ITEMS/Sample.jpg";
import SevenUpSugarFree16oz from "../images/FOOD_ITEMS/Sample.jpg";
import Tango16oz from "../images/FOOD_ITEMS/Sample.jpg";
import Blueberry454ml from "../images/FOOD_ITEMS/Sample.jpg";
import RobinsonsBlackberry500ml from "../images/FOOD_ITEMS/Sample.jpg";
import OrangeJuice200ml from "../images/FOOD_ITEMS/Sample.jpg";
import AppleJuice200ml from "../images/FOOD_ITEMS/Sample.jpg";
import Lucozade350ml from "../images/FOOD_ITEMS/Sample.jpg";
import MonsterEnergyWhiteUltra500ml from "../images/FOOD_ITEMS/Sample.jpg";
import RobinsonsRaspberry500ml from "../images/FOOD_ITEMS/Sample.jpg";

// Sides Items
import PotatoWedges from "../images/FOOD_ITEMS/PotatoWedges.png";
import HashBrown from "../images/FOOD_ITEMS/HashBrown.png";
import ChickenStrips from "../images/FOOD_ITEMS/ChickenStrips.png";
import ChickenSausages from "../images/FOOD_ITEMS/ChickenSausages.png";

// Sub Items
import OmeletteSub from "../images/FOOD_ITEMS/Sample.jpg";
import OmeletteSubWithBacon from "../images/FOOD_ITEMS/Sample.jpg";
import BoiledEggSub from "../images/FOOD_ITEMS/Sample.jpg";
import ChickenSausageSub from "../images/FOOD_ITEMS/Sample.jpg";
import BaconSub from "../images/FOOD_ITEMS/Sample.jpg";

// Snacks & Desserts
import Donuts from "../images/FOOD_ITEMS/Sample.jpg";
import OneCookie from "../images/FOOD_ITEMS/Sample.jpg";
import ChocolateMuffins from "../images/FOOD_ITEMS/Sample.jpg";
import BenJerryIcecream from "../images/FOOD_ITEMS/Sample.jpg";
import TwoCookies from "../images/FOOD_ITEMS/Sample.jpg";
import FourCookies from "../images/FOOD_ITEMS/Sample.jpg";
import Walkers from "../images/FOOD_ITEMS/Walkers.png";
import HarvestSnaps from "../images/FOOD_ITEMS/HarvestSnaps.png";

// Coffee & Hot Beverages
import Cappuccino340ml from "../images/FOOD_ITEMS/Cappuccino340ml.png";
import Mocha340ml from "../images/FOOD_ITEMS/Cappuccino340ml.png";
import RedBullEnergyDrink250ml from "../images/FOOD_ITEMS/Cappuccino340ml.png";
import Americano340ml from "../images/FOOD_ITEMS/Cappuccino340ml.png";
import HotChocolate340ml from "../images/FOOD_ITEMS/Cappuccino340ml.png";
import Latte340ml from "../images/FOOD_ITEMS/Cappuccino340ml.png";
import FlatWhite340ml from "../images/FOOD_ITEMS/Cappuccino340ml.png";
import Espresso340ml from "../images/FOOD_ITEMS/Cappuccino340ml.png";
import Tea340ml from "../images/FOOD_ITEMS/Cappuccino340ml.png";

// Wrap Items
import PepperoniWrap from "../images/FOOD_ITEMS/PepperoniWrap.png";
import SalamiWrap from "../images/FOOD_ITEMS/SalamiWrap.png";
import VegetablesWrap from "../images/FOOD_ITEMS/VegetablesWrap.png";
import ShreddedBeefWrap from "../images/FOOD_ITEMS/ShreddedBeefWrap.png";
import ChickenStripWrap from "../images/FOOD_ITEMS/ChickenStripWrap.png";
import ChickenTikkaWrap from "../images/FOOD_ITEMS/ChickenTikkaWrap.png";
import ChickenTeriyakiWrap from "../images/FOOD_ITEMS/ChickenTeriyakiWrap.png";
import PlainChickenWrap from "../images/FOOD_ITEMS/PlainChickenWrap.png";
import TurkeyWrap from "../images/FOOD_ITEMS/TurkeyWrap.png";
import MeatballWrap from "../images/FOOD_ITEMS/MeatballWrap.png";
import TunaWrap from "../images/FOOD_ITEMS/TunaWrap.png";
import HamWrap from "../images/FOOD_ITEMS/SalamiWrap.png";

// Bowl Items
import RiceBowl from "../images/FOOD_ITEMS/RiceBowl.png";
import PastaBowl from "../images/FOOD_ITEMS/PastaBowl.png";

// Salad Items
import ChickenTikkaSalad from "../images/FOOD_ITEMS/Sample.jpg";
import ChickenTeriyakiSalad from "../images/FOOD_ITEMS/Sample.jpg";
import PlainChickenSalad from "../images/FOOD_ITEMS/Sample.jpg";
import TurkeySalad from "../images/FOOD_ITEMS/Sample.jpg";
import MeatballsSalad from "../images/FOOD_ITEMS/Sample.jpg";
import TunaSalad from "../images/FOOD_ITEMS/Sample.jpg";
import HamSalad from "../images/FOOD_ITEMS/Sample.jpg";
import PepperoniSalad from "../images/FOOD_ITEMS/Sample.jpg";
import SalamiSalad from "../images/FOOD_ITEMS/Sample.jpg";
import VeggieSalad from "../images/FOOD_ITEMS/Sample.jpg";
import ShreddedBeefSalad from "../images/FOOD_ITEMS/Sample.jpg";

export const menuItemImageMapping = {
  // Sandwich Items
  "Chicken Tikka Sub": ChickenTikkaSandwich,
  "Chicken Teriyaki Sub": ChickenTeriyakiSandwich,
  "Plain Chicken Sub": PlainChickenSandwich,
  "Turkey Sub": TurkeySandwich,
  "Meatballs Sub": MeatballsSandwich,
  "Tuna Sub": TunaSandwich,
  "Ham Sub": HamSandwich,
  "Pepperoni Sub": PepperoniSandwich,
  "Salami Sub": SalamiSandwich,
  "Vegetable Sub": VegetableSandwich,
  "Shredded Beef Sub": ShreddedBeefSandwich,
  "Chicken Strip Sub": ChickenStripSandwich,
  "Create your own": CreateYourOwn,

  // Drinks
  "Pepsi 16oz 454 Ml": Pepsi16oz,
  "Water 500ml": Water500ml,
  "Pepsi Max 16oz 454 Ml": PepsiMax16oz,
  "7up Sugar Free 16oz 454 Ml": SevenUpSugarFree16oz,
  "Tango 16oz 454 Ml": Tango16oz,
  "Blueberry 454 Ml": Blueberry454ml,
  "Robinsons Blackberry 500ml": RobinsonsBlackberry500ml,
  "Orange Juice 200 Ml": OrangeJuice200ml,
  "Apple Juice 200 Ml": AppleJuice200ml,
  "Lucozade 350ml": Lucozade350ml,
  "Monster Enegry 500 Ml - White Ultra Energy": MonsterEnergyWhiteUltra500ml,
  "Robinsons Raspberry 500ML": RobinsonsRaspberry500ml,

  // Sides Items
  "Potato Wedges": PotatoWedges,
  "Hash Brown": HashBrown,
  "Chicken Strips": ChickenStrips,
  "Chicken Sausages": ChickenSausages,

  // Sub Items
  "Omelette Sub": OmeletteSub,
  "Omelette Sub with Bacon": OmeletteSubWithBacon,
  "Boiled Egg Sub": BoiledEggSub,
  "Chicken Sausage Sub": ChickenSausageSub,
  "Bacon Sub": BaconSub,

  // Snacks & Desserts
  "Donuts": Donuts,
  "1 cookies": OneCookie,
  "Chocolate Muffins": ChocolateMuffins,
  "Ben & Jerry Icecream": BenJerryIcecream,
  "2 cookies": TwoCookies,
  "4 cookies": FourCookies,
  "Walkers": Walkers,
  "Harvest Snaps": HarvestSnaps,

  // Coffee & Hot Beverages
  "Cappuccino 340 Ml": Cappuccino340ml,
  "Mocha 340 Ml": Mocha340ml,
  "Red Bull Energy Drink 250ml": RedBullEnergyDrink250ml,
  "Americano 340 Ml": Americano340ml,
  "Hot Chocolate 340 Ml": HotChocolate340ml,
  "Latte 340 Ml": Latte340ml,
  "Flat White 340 Ml": FlatWhite340ml,
  "Espresso 340 Ml": Espresso340ml,
  "Tea 340 Ml": Tea340ml,

  // Wrap Items
  "Pepperoni Wrap": PepperoniWrap,
  "Salami Wrap": SalamiWrap,
  "Vegetables Wrap": VegetablesWrap,
  "Shredded Beef Wrap": ShreddedBeefWrap,
  "Chicken Strip Wrap": ChickenStripWrap,
  "Chicken Tikka Wrap": ChickenTikkaWrap,
  "Chicken Teriyaki Wrap": ChickenTeriyakiWrap,
  "Plain Chicken Wrap": PlainChickenWrap,
  "Turkey Wrap": TurkeyWrap,
  "Meatball Wrap": MeatballWrap,
  "Tuna Wrap": TunaWrap,
  "Ham Wrap": HamWrap,

  // Bowl Items
  "Rice Bowl": RiceBowl,
  "Pasta Bowl": PastaBowl,

  // Salad Items
  "Chicken Tikka Salad": ChickenTikkaSalad,
  "Chicken Teriyaki Salad": ChickenTeriyakiSalad,
  "Plain Chicken Salad": PlainChickenSalad,
  "Turkey Salad": TurkeySalad,
  "Meatballs Salad": MeatballsSalad,
  "Tuna Salad": TunaSalad,
  "Ham Salad": HamSalad,
  "Pepperoni Salad": PepperoniSalad,
  "Salami Salad": SalamiSalad,
  "Veggie Salad": VeggieSalad,
  "Shredded Beef Salad": ShreddedBeefSalad,
  "Shawarma Salad": ShreddedBeefSalad,
  "Shawarma Bowl": ShreddedBeefSalad,
  "Shawarma Wrap": ShreddedBeefSalad,
  "Shawarma Sub": ShreddedBeefSalad,
  "Jacked Potato": ShreddedBeefSalad,
};

// Helper function to get specific image by item title
export const getMenuItemImage = (itemTitle) => {
  if (!itemTitle) {
    return samplePng;
  }

  // Try exact match first
  if (menuItemImageMapping[itemTitle]) {
    return menuItemImageMapping[itemTitle];
  }

  // Try case-insensitive match
  const exactMatch = Object.keys(menuItemImageMapping).find(
    key => key.toLowerCase() === itemTitle.toLowerCase()
  );
  if (exactMatch) {
    return menuItemImageMapping[exactMatch];
  }

  // Return fallback image if no match found
  return samplePng;
};


// Helper function to check if an item has a specific image
export const hasSpecificImage = (itemTitle) => {
  return menuItemImageMapping.hasOwnProperty(itemTitle) || 
         Object.keys(menuItemImageMapping).some(key => 
           key.toLowerCase() === itemTitle.toLowerCase()
         );
};